import { render } from "./KnowledgeResourceAdmin.vue?vue&type=template&id=170ab6ee&scoped=true"
import script from "./KnowledgeResourceAdmin.vue?vue&type=script&lang=js"
export * from "./KnowledgeResourceAdmin.vue?vue&type=script&lang=js"

import "./KnowledgeResourceAdmin.vue?vue&type=style&index=0&id=170ab6ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170ab6ee"]])

export default __exports__